module.exports = __webpack_public_path__ + "static/media/pm_image_icon.ce55e59a.svg";